import {Router, ActivatedRoute} from '@angular/router';
import {DataTable} from "../../services/DataTable";
import {ClientsService} from "../../models/clients/clients.service";

import {BadgesService} from "../../models/badges/badges.service";
import {BadgesHelper} from "../../services/BadgesHelper";

import {phoneFormatter} from "../../helpers/phone-format";

export abstract class BaseAccountsComponent{

    phoneFormatter = phoneFormatter;

    public dataTable: DataTable;
    public statuses: Array<any>;

    // ===========================================================
    // Init
    // ===========================================================

    constructor(
        protected router: Router,
        protected route: ActivatedRoute,
        public clientsService: ClientsService,
        public badgesService:BadgesService,
        public badgesHelper: BadgesHelper
    ) {
        this.dataTable = new DataTable(this.clientsService, this.getFields());
        ((() => {
            var a: any = document.createElement('a');
            a.href = router.url;
            var url: any = new URL(a.href);
            var q = url.searchParams.get('q');
            return (dataTable: any) => {
                if (q) dataTable.filter.q = q;
            };
        }) ()) (this.dataTable);
        this.dataTable.fetch();

        this.badgesService.onChange.subscribe((badgesObject)=> {
            badgesHelper.refreshEntity(badgesObject, this.dataTable);
            this.refreshTable();
        });
    }

    ngOnInit() {
        this.statuses =  this.clientsService.getStatusAccounts();
    }

    // ===========================================================
    // Actions
    // ===========================================================

    public openOne(model) {
        this.router.navigate(['clients/' + model.id], { relativeTo: this.route });
    }


    // ===========================================================
    // Functions
    // ===========================================================

    public refreshTable() {
        this.dataTable.refresh();
    }

    protected abstract getFields();
}


// WEBPACK FOOTER //
// ./src/app/modules/accounts/base.accounts.component.ts